module.exports = __webpack_public_path__ + "static/media/attractive-beautiful-beauty-584314 2.d25f8217.png";